<script>
    import NavBar from "../components/NavBar.svelte";
    import { initializeApp } from "firebase/app";
    import { getStorage, ref, uploadBytes} from "firebase/storage";
    import { getAuth } from "firebase/auth";
    import { db, auth } from "../firebase";
    import { collection, query, where, getDocs, addDoc, serverTimestamp } from "firebase/firestore"; 

    function uploadMMS() {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
            var file = document.querySelector('#mms').files[0];
            var fileType = file.type;
            var fileExt = "";
            if (fileType == "image/jpeg"){
                fileExt = "jpeg"
            }
            if (fileType == "image/jpg"){
                fileExt = "jpg"
            }
            if (fileType == "image/png"){
                fileExt = "png"
            }
            const storage = getStorage();
            const d = new Date();
            const imageRef = ref(storage, 'mms-image-uploads/'+user.uid+'/'+d.getFullYear()+'/'+d.getMonth()+'/'+d.getTime()+'.'+fileExt);
            uploadBytes(imageRef, file).then((snapshot) => {
                alert(JSON.stringify(snapshot.downloadURL));
            });
        }
    }

    async function sendSMS(to, message, mms){
        await addDoc(collection(db, "message-logs"), {
            toPhoneNumber: to,
            fromPhoneNumber: "+13203639436",
            SMSMessage: message,
            MMSLocation: mms,
            createdAt: serverTimestamp(),
            sender: "fOOlT8Md7uWr4C1vpF7yR7eJKMX2"
        });
    }

    async function sendMessage() {

        //uploadMMS()

        const contactsRef = collection(db, "contacts");
        const contactsQuery = query(contactsRef, where("owner", "==", "fOOlT8Md7uWr4C1vpF7yR7eJKMX2"));
        const querySnapshot = await getDocs(contactsQuery);
        const data = querySnapshot.docs.map(doc => doc.data());

        var message = document.getElementById('message').value;
        var mms = document.getElementById('mms').value;
        var dataLength = data.length;
        for (var i = 0; i < dataLength; i++) {
            var isdoubleOptIn = data[i].doubleOptIn;
            if(isdoubleOptIn == true) {
                var to = data[i].phoneNumber;

                setTimeout(sendSMS(to, message, mms), 1500);
            }
        }
        alert("Please wait a couple seconds for everything to finsh sending!");
    }

</script>

<div>
    <NavBar/>
    <div class="app-container">
        <div class="box">
            <div class="field">
                <label class="label">From Phone Number</label>
                <div class="control">
                    <input id="from" class="input" type="tel" placeholder="+55555555555" value="+1 (320) D-NexGen" disabled>
                </div>
            </div>
            <hr>
            <div class="field">
                <label class="label">SMS Message</label>
                <div class="control">
                    <textarea id="message" class="textarea" placeholder="Write your message!"></textarea>
                </div>
            </div>
            <hr>
            <label class="label">MMS Image URL (Note: Sending images has a higher cost)</label>
            <!-- <div class="file">
                <label class="file-label">
                    <input class="file-input" type="file" id="mms" accept=".png, .jpg, .jpeg">
                    <span class="file-cta">
                        <span class="file-label">
                            Upload an Image...
                        </span>
                    </span>
                </label>
            </div> -->
            <div class="control">
                <input id="mms" class="input" type="text" placeholder="https://" value="">
            </div>
            <hr>
            <div class="control">
                <button class="button is-dark" type="button" on:click={sendMessage}>Send</button>
                <!--<button class="button is-dark" type="button" on:click={sendMessage}>Send</button>-->
            </div>
        </div>
    </div>
</div>